import React from 'react';
import MultiplePublishCoupon from "@/Pages/Coupons/Assets/MultipleAddedCouponsAction/MultiplePublishCoupon";
import MultipleRemoveCoupon from "@/Pages/Coupons/Assets/MultipleAddedCouponsAction/MultipleRemoveCoupon";
import PermissionsGate from "@/Shared/PermissionsGate";

const MultipleAddedCouponsAction = ({checked}) => {
  return (
    <div className='flex'>
      <PermissionsGate scopes={['public-coupon']}>
        <MultiplePublishCoupon checked={checked}/>
      </PermissionsGate>
      <MultipleRemoveCoupon checked={checked}/>
    </div>
  );
};

export default MultipleAddedCouponsAction;
